const state = {
  // for each exercise part (object key = exercise part key), the list of the dropped propositions
  droppedPropositions: {},
};

const getters = {};

const actions = {
  /**
   * Add proposition in droppedPropositions[key]
   * @param {*} commit
   * @param {*} payload proposition & key
   */
  setPropositionDropped({ commit }, payload) {
    commit("SET_PROPOSITION_DROPPED", payload);
  },
  /**
   * Remove proposition from droppedPropositions[key]
   * @param {*} commit
   * @param {*} payload propositionContent & key
   */
  unsetPropositionDropped({ commit }, payload) {
    commit("UNSET_PROPOSITION_DROPPED", payload);
  },
  resetDroppedPropositions({ commit }, key) {
    commit("RESET_DROPPED_PROPOSITIONS", key);
  },
  setDroppedPropositionsList({ commit }, key) {
    commit("SET_DROPPED_PROPOSITIONS_LIST", key);
  },
  resetDroppedPropositionsList({ commit }) {
    commit("RESET_DROPPED_PROPOSITIONS_LIST");
  },
};

const mutations = {
  SET_PROPOSITION_DROPPED(state, payload) {
    if (
      payload.key in state.droppedPropositions &&
      state.droppedPropositions[payload.key].filter(
        (dp) => dp.id === payload.proposition.id,
      ).length === 0
    ) {
      state.droppedPropositions[payload.key].push(payload.proposition);
    }
  },
  UNSET_PROPOSITION_DROPPED(state, payload) {
    const i = state.droppedPropositions[payload.key].findIndex(
      (dp) => dp.content === payload.propositionContent,
    );
    if (i !== -1) {
      state.droppedPropositions[payload.key].splice(i, 1);
    }
  },
  RESET_DROPPED_PROPOSITIONS(state, key) {
    state.droppedPropositions[key] = [];
  },
  SET_DROPPED_PROPOSITIONS_LIST(state, key) {
    if (!(key in state.droppedPropositions)) {
      state.droppedPropositions[key] = [];
    }
  },
  RESET_DROPPED_PROPOSITIONS_LIST(state) {
    state.droppedPropositions = {};
  },
};

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations,
};
